import AppTopNavbar from './appTopNavbar';
import AppBottomNavbar from './appBottomNavbar';

export default {
  AppTopNavbar,
  AppBottomNavbar,
};
